import primaryComponents, {
  AsyncSelectField,
} from "../../../../primaryComponents";
import styles from "./styles.module.scss";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import {
  useGetPOCategories,
  useGetSuppliersForSelectField,
} from "../../../../../hooks/api/queries";
import secondaryComponents from "../../..";
import { useState } from "react";
import { RoutedModal } from "../../../../common";
import { POCategoriesForm } from "../../../POCategories";

export const BasicInfo = ({
  PODetails,
  pOForm,
  setPOForm = () => {},
  ...validationParams
}) => {
  const { loadOptions: loadSuppliersOptions } = useGetSuppliersForSelectField(
    {},
  );

  const { data, isLoading: isLoadingPOCategories } = useGetPOCategories({});
  const pOCategories = data?.data || [];

  const [views, setViews] = useState({
    isNewSupplier: false,
    isNewPOCategory: false,
  });

  const {
    register,
    control,
    formState: { errors },
    trigger,
  } = validationParams;

  return (
    <>
      <div className={styles.basicInfo}>
        <secondaryComponents.LoaderHelper
          classNames={"my-4"}
          isLoading={isLoadingPOCategories}
        >
          <div
            className={`${globalStyles.cardWithBorder} flex-md-row w-100 pb-1`}
            style={{ columnGap: "15px" }}
          >
            <div className="w-100">
              <AsyncSelectField
                control={control}
                name={"supplier_id"}
                register={register}
                isRequired
                value={`${pOForm?.supplier_name}`}
                label={
                  <span>
                    Supplier (
                    <span
                      className="d-inline-block purple--text cursor-pointer"
                      onClick={() =>
                        setViews((prev) => ({ ...prev, isNewSupplier: true }))
                      }
                    >
                      Add new supplier
                    </span>
                    )
                  </span>
                }
                nameKey={"name"}
                idKey={"id"}
                classNames="white"
                loadOptions={loadSuppliersOptions}
                errorMessage={errors?.supplier_id}
                isDisabled={PODetails?.status === "ACCEPTED"}
                onChange={(value) => {
                  setPOForm((prevState) => ({
                    ...prevState,
                    supplier_id: value,
                  }));
                }}
              />
            </div>
            <div className="w-100">
              <primaryComponents.SelectFieldV2
                control={control}
                name={"category_id"}
                register={register}
                label={
                  <span>
                    <span>Category </span>(
                    <span
                      className="d-inline-block purple--text cursor-pointer"
                      onClick={() =>
                        setViews((prev) => ({ ...prev, isNewPOCategory: true }))
                      }
                    >
                      Add new category
                    </span>
                    )
                  </span>
                }
                value={
                  pOCategories?.find(
                    (pOCategory) =>
                      `${pOCategory?.id}` === `${pOForm?.category_id}`,
                  )?.name || "Select category"
                }
                classNames="white"
                isRequired
                options={pOCategories}
                idKey="id"
                nameKey="name"
                errorMessage={errors?.category_id}
                onChange={(value) => {
                  setPOForm((prevState) => ({
                    ...prevState,
                    category_id: value,
                  }));
                }}
              />
            </div>
            <primaryComponents.DateInputV2
              control={control}
              name={"po_date"}
              register={register}
              label={"PO Date"}
              classNames="white"
              isRequired
              value={pOForm.po_date}
              errorMessage={errors?.po_date}
              onKeyUp={() => errors?.po_date && trigger("po_date")}
              onChange={({ target: { value } }) => {
                setPOForm((prevState) => ({
                  ...prevState,
                  po_date: value,
                }));
              }}
            />
          </div>
        </secondaryComponents.LoaderHelper>
      </div>

      <RoutedModal
        isActive={views.isNewPOCategory}
        closeModal={() =>
          setViews((prev) => ({ ...prev, isNewPOCategory: false }))
        }
        width={550}
        headerTitle="Create Procurement Category"
        style={{ height: "auto" }}
      >
        <POCategoriesForm
          closeModal={() =>
            setViews((prev) => ({ ...prev, isNewPOCategory: false }))
          }
        />
      </RoutedModal>

      <RoutedModal
        isActive={views.isNewSupplier}
        closeModal={() =>
          setViews((prev) => ({ ...prev, isNewSupplier: false }))
        }
        width={550}
        headerTitle="Add New Supplier"
        style={{ height: "auto" }}
      >
        <secondaryComponents.SupplierForm
          closeWidget={() =>
            setViews((prev) => ({ ...prev, isNewSupplier: false }))
          }
        />
      </RoutedModal>
    </>
  );
};
